import { apiAxios } from "./api-config/apiConfig";

/* =======================
   TYPES
======================= */

export interface MessageCreator {
  id: string;
  name: string;
}

export interface MessageItem {
  id: string;
  messageDetail: string;
  createdBy: string;
  createdAt: string;
  creator: MessageCreator;
}

export interface RecentMessageData {
  count: number;
  rows: MessageItem[];
}

export interface RecentMessageResponse {
  status: boolean;
  data: RecentMessageData;
}

/* =======================
   API
======================= */

export const getRecentMessages = async (
  pageId: number = 1,
  limit: number = 10,
): Promise<RecentMessageResponse> => {
  const response = await apiAxios.get<RecentMessageResponse>(
    `/message/list?pageId=${pageId}&limit=${limit}`,
  );

  return response.data;
};
